import React, { ChangeEvent, Component } from "react";
import classnames from "classnames";
import isValid from "date-fns/fp/isValid";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { InputElement } from "@formant/ui/component/common/Field";

import { appStore, observeStore } from "../../stores";
import { formatDate } from "../../utils/formatDate";
import { fromUtc } from "../../utils/fromUtc";
import * as styles from "./TimeEdit.scss";

export interface ITimelineTimeEditProps {
    className?: string;
    disabled?: boolean;
}

@observer
export class TimelineTimeEdit extends Component<ITimelineTimeEditProps> {
    @observable
    private value: string | undefined;

    public render() {
        const { value, onBlur } = this;
        const { className, disabled } = this.props;
        const { humanTime } = observeStore;

        return (
            <input
                type="time"
                className={classnames(styles["time-edit"], className)}
                value={value || humanTime}
                step={1}
                required={true}
                onChange={this.onChange}
                onBlur={onBlur}
                disabled={disabled}
                data-testid="time-edit"
            />
        );
    }

    private onChange = (event: ChangeEvent<InputElement>) => {
        const { time } = observeStore;
        const { value } = event.target;
        this.value = value;
        let newTime = new Date(`${formatDate(time)} ${value}`);
        if (appStore.utc) {
            newTime = fromUtc(newTime);
        }
        if (isValid(newTime)) {
            observeStore.pauseAt(newTime);
        }
    };

    private onBlur = () => {
        this.value = undefined;
    };
}
